module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAZCAYAAABD2GxlAAAABGdBTUEAALGPC/xhBQAAAR5JREFUSA3N170OgjAQB3Bby+wohMHFwZ2JTRffwAcx8QF8FJ/CUeJoArO6ER1YnE1kEP/HQEQR6ld6TS60tJf+KAkX2q03mu/7rm3bC8dxVkmSnN9I/Xip0s0kXJqmgRCiq5TqIe+km/vNOqGTfI/LsmwcRdFGJ+8XaxqBJnH0gLVA07haIAfcSyAXXCWQE+4JyA1XAnLEFUCuuBwIXB8VYo1BBzGTUm5pgkOzLCsWnucdgXERtd9EE2CU1blC6Zqgs0RcgZjiejCBqdozP0GawCkOAAuoD/AItXZHfQ6teK1ckQWQTosjsgTkiHwCckNWAjkhXwK5IGuBHJCNQNNILeAjEuNhGIZ7uv/vJnU3oOpCVQYR47fzopv37bobVT7XwSSpYtIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/gallery/arrow_left.png
// module id = 537
// module chunks = 104101334113578